export const NuxtApollo = {
 proxyCookies: true,
 clientAwareness: false,
 cookieAttributes: {"maxAge": 604800, "secure": true, "sameSite": "lax"},
 clients: {"default": {"httpEndpoint": "https://uat-kalkhoff.pon.bike/graphql", "httpLinkOptions": {"credentials": "include"}, "authType": "Bearer", "authHeader": "Authorization", "tokenName": "apollo:default.token", "tokenStorage": "cookie", "defaultOptions": {}}}
}